export const MOBILE_OS_IOS = 'ios';
export const MOBILE_OS_ANDROID = 'android';
export const MOBILE_OS_UNKNOWN = 'unknown';

export type MobileOS =
  | typeof MOBILE_OS_IOS
  | typeof MOBILE_OS_ANDROID
  | typeof MOBILE_OS_UNKNOWN;

export function getMobileOS(): MobileOS {
  if (typeof window === 'undefined') {
    return MOBILE_OS_UNKNOWN;
  }

  const userAgent = navigator.userAgent.toLowerCase();
  if (/ipad|iphone|ipod/.test(userAgent)) {
    return MOBILE_OS_IOS;
  }

  if (/android/i.test(userAgent)) {
    return MOBILE_OS_ANDROID;
  }

  return MOBILE_OS_UNKNOWN;
}
